// Angular
import { Pipe, PipeTransform, inject } from '@angular/core';
// Transloco
import { TranslocoService } from '@jsverse/transloco';

type Duration = {
  days?: number;
  hours?: number;
  minutes?: number;
};

@Pipe({ name: 'orderHandlingTime' })
export class OrderHandlingTimePipe implements PipeTransform {

  private translocoService = inject(TranslocoService);

  transform(value: Duration | null | undefined): string {
    const label = this.translocoService.translate('sentence_order_handling_time');

    if (!value) return label;

    const days = value.days ?? 0;
    const hours = value.hours ?? 0;
    const minutes = value.minutes ?? 0;

    const parts: string[] = [];

    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);

    const durationText = parts.length ? parts.join(' ') : '0m';

    return `${durationText} ${label}`;
  }
}
